export default function Affirmation() {
  return (
    <section
      data-testid="affirmation-section"
      className="relative py-28 lg:py-40 overflow-hidden"
    >
      <img
        src="https://images.unsplash.com/photo-1612153018787-4899c6e056d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxzYWdlJTIwZ3JlZW4lMjBhYnN0cmFjdCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzgxMTgzMjY4fDA&ixlib=rb-4.1.0&q=85"
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#2C3B2E]/55" />
      <div className="absolute inset-0 aw-vignette" />

      <div className="relative mx-auto max-w-5xl px-6 lg:px-10 text-center">
        <p className="text-[11px] tracking-eyebrow uppercase text-cream/70 mb-8">
          A reflection
        </p>
        <blockquote
          data-testid="affirmation-quote"
          className="font-serif-display italic text-cream text-3xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-tight"
        >
          “Until you make the unconscious conscious,
          <br className="hidden sm:block" />
          it will direct your life and you will call it fate.”
        </blockquote>
        <p
          data-testid="affirmation-attribution"
          className="mt-8 font-serif-display text-cream text-xl sm:text-2xl"
        >
          — Carl Jung
        </p>
        <p className="mt-10 text-cream/70 tracking-[0.3em] uppercase text-xs">
          Heal · Release · Rise
        </p>
      </div>
    </section>
  );
}
